<ap-panel
    class="ap-flex ap-flex-grow-1 ap-justify-content-center ap-align-content-center ap-text-align-center ap-margin-bottom-0"
    type="primary"
    aria-describedby="chat_overlay_message"
    aria-live="assertive"
>
    <div ap-panel-body>
        <h3 id="chat_overlay_message">{{ 'conversational.chat.overlay.message.title' | apContent }}</h3>
        <ap-button (onClick)="setContinueConversation()" aria-describedby="chat_overlay_message">
            {{ 'conversational.chat.overlay.message.button.continue' | apContent }}
        </ap-button>
    </div>
</ap-panel>
